import { DateFilterOptionsEnum } from './date-filter-options.enum';

export interface DateFilterOption {
  id: string;
  text: string;
}

export const dateFilterSource: DateFilterOption[] = [
  {
    id: DateFilterOptionsEnum.thisMonth,
    text: 'MM.fields.filter.dateOptions.thisMonth'
  },
  {
    id: DateFilterOptionsEnum.lastMonth,
    text: 'MM.fields.filter.dateOptions.lastMonth'
  },
  {
    id: DateFilterOptionsEnum.thisYear,
    text: 'MM.fields.filter.dateOptions.thisYear'
  },
  {
    id: DateFilterOptionsEnum.lastYear,
    text: 'MM.fields.filter.dateOptions.lastYear'
  },
  {
    id: DateFilterOptionsEnum.customRange,
    text: 'MM.fields.filter.dateOptions.customRange'
  }
];